import React from "react";

type BrandVariant = "sidebar" | "marketing";

interface BrandWordmarkProps {
  theme: string;
  variant?: BrandVariant;
  className?: string;
}

const fontStack = "Inter, Segoe UI, system-ui, sans-serif";

const BrandWordmark: React.FC<BrandWordmarkProps> = ({
  theme,
  variant = "sidebar",
  className = "",
}) => {
  const isDark = theme === "dark";

  if (variant === "marketing") {
    return (
      <div className={`flex flex-col leading-none select-none ${className}`}>
        <div className="flex items-baseline">
          <span
            className={`text-[1.6rem] sm:text-[1.85rem] font-bold tracking-[-0.04em] antialiased transition-all duration-300 group-hover:tracking-[-0.03em] ${
              isDark
                ? "bg-gradient-to-br from-white via-slate-100 to-slate-300 bg-clip-text text-transparent"
                : "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-600 bg-clip-text text-transparent"
            }`}
            style={{ fontFamily: fontStack }}
          >
            Aether
          </span>
          <span
            className={`text-[1.6rem] sm:text-[1.85rem] font-bold tracking-[-0.04em] antialiased transition-all duration-300 group-hover:tracking-[-0.02em] ${
              isDark
                ? "bg-gradient-to-r from-blue-300 via-cyan-300 to-sky-400 bg-clip-text text-transparent [text-shadow:0_0_30px_rgba(56,189,248,0.35)]"
                : "bg-gradient-to-r from-blue-700 via-cyan-600 to-blue-800 bg-clip-text text-transparent"
            }`}
            style={{ fontFamily: fontStack }}
          >
            Flow
          </span>
        </div>
        <div className="mt-1.5 flex items-center gap-2">
          <span
            className={`h-px w-5 shrink-0 ${
              isDark ? "bg-gradient-to-r from-cyan-400/80 to-transparent" : "bg-gradient-to-r from-blue-600/80 to-transparent"
            }`}
          />
          <span
            className={`text-[0.5rem] sm:text-[0.52rem] font-bold uppercase tracking-[0.24em] ${
              isDark ? "text-cyan-300/85" : "text-blue-700/85"
            }`}
          >
            Systems
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col leading-none ${className}`}>
      <span
        className={`text-[1.4rem] font-semibold tracking-[-0.01em] antialiased transition-all duration-300 ${
          isDark
            ? "bg-gradient-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent"
            : "bg-gradient-to-r from-gray-900 via-blue-800 to-cyan-700 bg-clip-text text-transparent"
        } group-hover:tracking-[0.005em]`}
        style={{ fontFamily: fontStack }}
      >
        AetherFlow
      </span>
      <span
        className={`mt-1 inline-flex w-fit rounded-full px-2 py-0.5 text-[0.58rem] font-semibold uppercase tracking-[0.14em] ${
          isDark
            ? "bg-blue-500/15 text-blue-200 ring-1 ring-blue-400/30"
            : "bg-blue-50 text-blue-700 ring-1 ring-blue-200"
        }`}
      >
        Workspace
      </span>
    </div>
  );
};

export default BrandWordmark;
